import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/http/auth.service';
import { UserService } from 'src/app/services/http/user.service';

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss']
})
export class GlobalHeaderComponent implements OnInit{
  @Input() expandSidebar: boolean = false;
  @Output() expandSidebarChange = new EventEmitter();
  
  name: string = '';
  lastName: string = '';

  @Input() border: string = 'none';

  showIcon: boolean=true;
  @Output() showNotification: boolean = false;

  showSwitchModule: boolean = true;
  currentModule: string = '';

  id: number = 0;
  email: string = '';

  searchText: string = '';
  showSearchInput: boolean = true;
  // componentName: ComponentNames = ComponentNames.NoComponent;
  private ngUnsubscribe = new Subject<void>();
  public initial: string = '';

  public loggedInUser: User = new User();

  constructor(private authService: AuthService, 
    private userService: UserService, private toastr: ToastrService, private router: Router, private route: ActivatedRoute) {
    this.router.events.subscribe(
      (event) => {
        this.currentModule = this.route.snapshot.data['currentModule'];
        if (event instanceof ActivationEnd && event.snapshot.children.length == 0){
          // this.componentName = event.snapshot.data['componentName'];
          this.showIcon=event.snapshot.data['showIcon'];
          this.showSwitchModule=event.snapshot.data['showSwitchModule'];
          //this.currentModule = event.snapshot.data['currentModule'];
        }
      });
   }

  logout(){
  }
  
  onActivate() {
  }

  ngOnInit(): void {

  }

  selectUser(email: any) {

  } 
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  expand(){
    this.expandSidebar = !this.expandSidebar;
    this.expandSidebarChange.emit(this.expandSidebar);
  }

  alert(){
    this.toastr.warning("Not yet implemented");
  }
  


}
